module.exports = __webpack_public_path__ + "img/Hockey.34ec8a2e.png";